import type { FC } from 'react';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { useOptionalPlatformSettings } from 'src/apis/monolith/use-platform-settings';
import { useOptionalOrganisationService } from 'src/apis/organisation-service/use-organisation-service';
import { useSecondaryMarketService } from 'src/apis/secondary-market-service/use-secondary-market-service';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { BulletinBoardNoticeCreate } from 'src/pages/transport/secondary-trading/bulletin-board/create';
import { BulletinBoardNoticeDetails } from 'src/pages/transport/secondary-trading/bulletin-board/details';
import { BulletinBoardNoticeEdit } from 'src/pages/transport/secondary-trading/bulletin-board/edit';

const NonTsoPage = lazy(() => import('./page'));

export const SecondaryTradingNonTsoOverview: FC = () => {
  const platformSettings = useOptionalPlatformSettings();
  const secondaryMarketService = useSecondaryMarketService();
  const organisationService = useOptionalOrganisationService();

  if (
    platformSettings?.loaded === false ||
    (PRISMA_CONFIG.secondaryMarketService &&
      (!secondaryMarketService.response || !organisationService.loaded))
  )
    return <PageSpinner />;

  return (
    <RootRoutes>
      <Route
        path="/transport/secondary"
        element={<Navigate replace to="/transport/secondary/offers" />}
      />
      <Route
        path="/transport/secondary/offers"
        element={
          <NonTsoPage
            platformSettings={platformSettings?.response?.data}
            selectedTab="OFFERS"
            secondaryMarketService={secondaryMarketService}
            organisationService={organisationService}
          />
        }
      />
      <Route
        path="/transport/secondary/requests"
        element={
          <NonTsoPage
            platformSettings={platformSettings?.response?.data}
            selectedTab="REQUESTS"
            secondaryMarketService={secondaryMarketService}
            organisationService={organisationService}
          />
        }
      />
      <Route
        path="/transport/secondary/bulletin-board"
        element={
          <NonTsoPage
            platformSettings={platformSettings?.response?.data}
            selectedTab="BULLETIN_BOARD"
            secondaryMarketService={secondaryMarketService}
            organisationService={organisationService}
          />
        }
      />
      <Route
        path="/transport/secondary/bulletin-board/:bulletinBoardNoticeId"
        element={
          <BulletinBoardNoticeDetails
            secondaryMarketService={secondaryMarketService}
          />
        }
      />
      <Route
        path="/transport/secondary/bulletin-board/create"
        element={
          <BulletinBoardNoticeCreate
            secondaryMarketService={secondaryMarketService}
          />
        }
      />
      <Route
        path="/transport/secondary/bulletin-board/:bulletinBoardNoticeId/edit"
        element={
          <BulletinBoardNoticeEdit
            secondaryMarketService={secondaryMarketService}
          />
        }
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
